var throttleTime = null
export const throttle = (fn, time) => {
  clearTimeout(throttleTime)
  throttleTime = null
  throttleTime = setTimeout(() => {
    fn()
  }, time)
}

var isOk = true
export const antiShake = (fn, time) => {
  if (!isOk) return
  isOk = false
  fn()
  setTimeout(() => {
    isOk = true
    fn()
  }, time)
}